import React, { useEffect, useState } from "react";
import "./RestaurantList.scss";
import noImg from "../../assets/images/no-image.svg";
import EnabillLogo from "../../assets/images/enabill.png";
import milkbunLogo from "../../assets/images/milkBunSmall.png";
import axios from "axios";
import IsClosed from "../../Pages/IsClosed";
import { get_lang } from "../../../../global-functions/apiGlobal";
import { useDispatch, useSelector } from "react-redux";
import { IconButton } from "@material-ui/core";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../../redux-store/store";
import { Container, Row, Col, Card, Button, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const RestaurantList = ({ tableNumber = 1, language = `ar` }) => {
  const appState = useSelector((state) => state);
  const appDispatch = useDispatch();
  const { setDeliveryAddsInfo, setLangValue, setGuestLoggedIn, setUserAddressPopup, setDeliveryDateTimePopup, setGuestModal, setUserSaveDeliveryAdds } = bindActionCreators(
    actionCreators,
    appDispatch
  );
  const history = useHistory();
  const [storeList, setStoreList] = useState([]);
  const closeDeliveryOptions = (delivery) => {
    if (delivery) {
      appDispatch({
        type: "setInvoiceTaxesChargesExtras",
        invoiceTaxesChargesExtras: [],
      });
    } else {
      setDeliveryAddsInfo(null);
      setUserAddressPopup(false);
      setGuestLoggedIn(false);
      setDeliveryDateTimePopup(false);
      setGuestModal(false);
      setUserSaveDeliveryAdds(false);
      appDispatch({
        type: "setDeliveryAddsPopup",
        deliveryAddsPopup: false,
      });
      appDispatch({
        type: "setCountryCityArea",
        countryCityArea: null,
      });
    }
  };
  useEffect(() => {
    const handleGetDeliveryStores = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/delivery/store`
        );
        if (response?.data?.success) {
          const arry = response.data.data.map((store) => ({
            storeId: store?.id,
            storeSlug: store?.slug,
            IsClosed: store?.is_closed,
            progressive: store?.progressive,
            storeDescription: store?.business?.description,
            storeCover: store?.business?.cover,
            storeName: store?.business?.name,
            storeLogo: store?.business?.logo,
          }));
          setStoreList(arry);
        }
      } catch (error) {
        console.error(error);
      }
    };
    handleGetDeliveryStores();
    closeDeliveryOptions(true);
  }, []);

  const handleLangChange = (lang) => {
    setLangValue(lang);
  };

  const handleGotostore = (storeSlug) => {
    console.log(storeSlug);
    history.push(`/${storeSlug}`);
  };

  if (storeList?.length === 0) {
    return (
      <Container
        fluid
        className="d-flex vh-100 justify-content-center align-items-center"
      ></Container>
    );
  }

  return (
    <Container
      fluid
      className=""
      id="restaurant-list"
      style={{
        direction: appState.langValue === "ar" ? "rtl" : "ltr",
      }}
    >
      <Row className="justify-content-center">
        <Col lg={2} className="d-none d-lg-block"></Col>

        <Col xs={12} lg={6} className="center-div">
          {/* Header */}
          <header className="d-flex justify-content-between align-items-center mb-4 bt-3 restaurant-header">
            <div className="m-1">
              <img src={milkbunLogo} alt="Logo" className="logo" />
            </div>
            <div className="d-flex align-items-center gap-3">
              {appState.langValue === "ar" ? (
                <Button
                  variant="outline-secondary"
                  id="headerBtn"
                  onClick={() => handleLangChange("en")}
                >
                  EN
                </Button>
              ) : (
                <Button
                  variant="outline-secondary"
                  id="headerBtn"
                  onClick={() => handleLangChange("ar")}
                >
                  عربي
                </Button>
              )}
            </div>
          </header>

          {/* Main Content */}
          <section>
            <h2 className="mb-2 familySora600 heading">All Restaurants</h2>
            <Row className="gy-3">
              {storeList?.map((store, index) => (
                <Col xs={12} key={index} className="my-3 px-4">
                  <Card className="border-0 shadow-sm">
                    <Card.Body
                      className="d-flex align-items-center p-4"
                      style={{
                        // boxShadow: "rgba(0, 0, 0, 0.2) 0px 8px 15px",
                        background: `url(${
                          store?.storeCover ? store.storeCover : noImg
                        }) center center / cover no-repeat`,
                        margin: "13px",
                      }}
                      onClick={() => handleGotostore(store?.storeSlug)}
                    ></Card.Body>
                    <span className={`d-flex align-items-center ${appState.langValue === "ar" ? "store-name-logo-class-ar " : "store-name-logo-class-en "} `} 
                      onClick={() => handleGotostore(store?.storeSlug)}
                        >
                      <img
                        src={store?.storeLogo ? store.storeLogo : noImg}
                        alt={store?.storeSlug}
                        className="rounded me-3 card"
                        style={{ width: "60px", height: "60px" }}
                      />
                      <div>
                        <h5 className="mb-1 mx-3 store-name">
                          {get_lang(store?.storeName, appState.langValue)}
                        </h5>
                      </div>
                    </span>
                  </Card>
                </Col>
              ))}
            </Row>
          </section>

          {/* Footer */}
          <footer className="text-center mt-4" style={{direction: 'ltr'}}>
            <p className="m-2 ">
              Pay securely with <strong> <img src={milkbunLogo} alt="" /> </strong>
            </p>
          </footer>
        </Col>

        <Col lg={2} className="d-none d-lg-block"></Col>
      </Row>
    </Container>
  );
};

export default RestaurantList;
